"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ErrorDisplay = _interopRequireDefault(require("../../TextElements/FormattedTextElements/ErrorDisplay"));

var _validate = require("../../../utils/inputValidator/validate");

var _LabeledRadioGroup = require("./LabeledRadioGroup.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** The LabeledRadioGroup is intended for use within a form, but can be used as a standalone if validation is not required
 *    If you do require validation, the group has only been tested using the SUBMIT validation rule as the others didn't make immediate sense
 * */
var LabeledRadioGroup = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(LabeledRadioGroup, _React$PureComponent);

  var _super = _createSuper(LabeledRadioGroup);

  function LabeledRadioGroup(props) {
    var _this;

    _classCallCheck(this, LabeledRadioGroup);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "validateAllRules", function () {
      var value = _this.props.value;
      var currentErrors = _this.state.errors;

      var errors = _this.validate({
        value: value,
        currentErrors: currentErrors
      });

      _this.setState({
        errors: errors
      });

      return errors;
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      _this.props.onChange(e.target.value);
    });

    _defineProperty(_assertThisInitialized(_this), "validateInput", function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$type = _ref.type,
          type = _ref$type === void 0 ? undefined : _ref$type,
          _ref$value = _ref.value,
          value = _ref$value === void 0 ? _this.props.value : _ref$value;

      var currentErrors = _this.state.errors;

      var errors = _this.validate({
        type: type,
        value: value,
        currentErrors: currentErrors
      });

      _this.setState({
        errors: errors
      });

      return errors;
    });

    _this.state = {
      errors: _toConsumableArray(props.errors)
    };
    _this.validate = (0, _validate.validate)({
      displayName: props.displayName,
      rules: props.validationRules
    });
    return _this;
  }

  _createClass(LabeledRadioGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          options = _this$props.options,
          title = _this$props.title,
          value = _this$props.value;
      var errors = this.state.errors;
      return /*#__PURE__*/_react.default.createElement(_LabeledRadioGroup.GroupWrapper, {
        className: className
      }, title && /*#__PURE__*/_react.default.createElement(_LabeledRadioGroup.GroupTitle, null, title), /*#__PURE__*/_react.default.createElement(_LabeledRadioGroup.GroupOptions, null, options.map(function (option) {
        return /*#__PURE__*/_react.default.createElement(_LabeledRadioGroup.StyledRadioButton, {
          id: "radio-group-option-".concat(option.label.replace(/\s+/g, '-')),
          key: option.value || option.label,
          checked: (option.value || option.label) === value,
          dataTestId: "radio-group-option-".concat(option.label.replace(/\s+/g, '-')),
          label: option.label,
          onChange: _this2.handleChange,
          value: option.value
        });
      })), /*#__PURE__*/_react.default.createElement(_ErrorDisplay.default, {
        errors: errors
      }));
    }
  }]);

  return LabeledRadioGroup;
}(_react.default.PureComponent);

_defineProperty(LabeledRadioGroup, "propTypes", {
  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** The display name is used when presenting error messages */
  displayName: _propTypes.default.string,

  /** Flag used for indicating an error state for the input */
  errors: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),

  /** Options that will map to radio buttons */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.string
  })).isRequired,

  /** Optional title for the radio group */
  title: _propTypes.default.string,

  /** Used to set the an initially checked option */
  value: _propTypes.default.string,
  // VALIDATION //

  /** Controls when validation is triggered */
  validationRules: _propTypes.default.objectOf(_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]))),
  // EVENTS //
  onChange: _propTypes.default.func.isRequired
});

_defineProperty(LabeledRadioGroup, "defaultProps", {
  className: '',
  displayName: 'Select one',
  errors: [],
  title: undefined,
  validationRules: {},
  value: undefined
});

var _default = LabeledRadioGroup;
exports.default = _default;